import { createReducer } from '@reduxjs/toolkit'
import { toggleSidebar } from '../actions/SidebarAction'

const initialSidebar = {
  sidebarOpen: false
}

const sidebarReducer = createReducer(initialSidebar, (builder) => {
  builder.addCase(toggleSidebar, (state) => {
    state.sidebarOpen = !state.sidebarOpen
  })
})

export { sidebarReducer }
